import { useState } from 'react';
import { useSubscription } from '@apollo/client';
import { MESSAGES } from '@guuru/chat-common';
import TIMEOUT_STATUS from '../subscriptions/WaitTimeoutMessage';

interface WaitTimeout {
  text?: string | null;
  waitTimeoutStatus: keyof typeof MESSAGES;
}

export default (messageId: string | null, chatId: string, skip: boolean) => {
  const [
    waitTimeoutUpdate,
    setWaitTimeoutUpdate,
  ] = useState<WaitTimeout | null>();

  useSubscription(TIMEOUT_STATUS, {
    variables: { id: chatId },
    skip: !messageId || skip,
    onData: ({ data: { data } }) => {
      setWaitTimeoutUpdate({
        text: data?.waitTimeoutMessage?.text,
        waitTimeoutStatus: data?.waitTimeoutMessage?.metadata.waitTimeoutStatus,
      });
    },
  });

  return waitTimeoutUpdate;
};
